/** @jsxImportSource @emotion/react */
import {
  createStyles,
  Input,
  ListItem,
  Setters,
  Errors,
  Switch,
  Typography,
} from '@quickbit/qb-design-system';
import { Platform } from './types';

interface Props {
  formFields: Platform;
  formErrors: Errors<Platform>;
  formSetters: Setters<Platform>;
  editable: boolean;
}

export const PlatformForm = ({
  formFields,
  formErrors,
  formSetters,
  editable,
}: Props) => {
  const styles = useStyles();

  return (
    <>
      <form css={[styles.container, styles.inputWrapper]}>
        <div>
          <Typography variant="bodyBold">Default order cancellation</Typography>
          <Input
            label="Cancel after"
            type="number"
            value={formFields.defaultMinutesToCancelOrderAfter.toString()}
            onChange={(e) => {
              if (e.target.value) {
                const value = Number(e.target.value);
                if (value < 0) return;
                formSetters.defaultMinutesToCancelOrderAfter.set(
                  parseInt(e.target.value)
                );
              } else {
                formSetters.defaultMinutesToCancelOrderAfter.set(0);
              }
            }}
            endAdornment="minutes"
            error={!!formErrors.defaultMinutesToCancelOrderAfter}
            helperText={formErrors.defaultMinutesToCancelOrderAfter}
          />
          <ListItem
            title="Cancel orders on error"
            css={[styles.listItemBorder, !editable && styles.listItemDisabled]}
            action={
              <Switch
                checked={formFields.defaultCancelOrderOnError}
                onChange={(checked) => {
                  formSetters.defaultCancelOrderOnError.set(checked);
                }}
                disabled={!editable}
              />
            }
            disabled={!editable}
          />
        </div>

        <div>
          <Typography variant="bodyBold">Default order callbacks</Typography>
          <ListItem
            title="Retry order callbacks"
            css={[styles.listItemBorder, !editable && styles.listItemDisabled]}
            action={
              <Switch
                checked={formFields.defaultRetryOrderCallbacks}
                onChange={(checked) => {
                  formSetters.defaultRetryOrderCallbacks.set(checked);
                  console.log(formFields.defaultRetryOrderCallbacks);
                }}
                disabled={!editable}
              />
            }
            disabled={!editable}
          />
        </div>
      </form>
    </>
  );
};

const useStyles = createStyles(({ spacing, shape, palette }) => ({
  container: {
    background: palette.white,
    borderRadius: shape.borderRadius,
  },
  inputWrapper: {
    marginBottom: 'auto',
    padding: spacing.xxs,
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.xxs,
    border: `1px solid ${palette.grey.x100}`,
  },
  listItemBorder: {
    borderRadius: spacing.xxxs,
    border: `1px solid ${palette.grey.x200}`,
    ':hover': {
      borderColor: palette.grey.x600,
    },
  },
  listItemDisabled: {
    ':hover': {
      borderColor: 'inherit',
    },
  },
}));
